import { CalendarRangeType } from '../calendar-filter.model';
import { Message } from '../message.model';

// Interfaces base
export interface DatePreviousPeriodOccupationByHours {
  fecha_inicial: string;
  fecha_final: string;
}

// Tipos literales
export type TipoAcceso = 'perimetrales' | 'internas';

// Base común para todos los tipos de body
interface BaseBody {
  sector: string;
  sucursal: string;
  tipo_acceso: TipoAcceso;
  fecha_periodo_anterior?: DatePreviousPeriodOccupationByHours;
}

// Union type para el body
export type BodyOccupationByHours =
  | (BaseBody & {
      Tipo_consulta_BD: CalendarRangeType.RANGO_MESES;
      mes_inicial: string;
      mes_final: string;
      mes_inicial_comp?: string;
      mes_final_comp?: string;
    })
  | (BaseBody & {
      Tipo_consulta_BD: CalendarRangeType.RANGO_DIAS;
      fecha_inicial: string;
      fecha_final: string;
      fecha_inicial_comp?: string;
      fecha_final_comp?: string;
    })
  | (BaseBody & {
      Tipo_consulta_BD: CalendarRangeType.MES_ACTUAL;
      mes_actual: string;
      mes_actual_comp?: string;
    })
  | (BaseBody & {
      Tipo_consulta_BD: CalendarRangeType.MES_ANTERIOR;
      mes_anterior: string;
      mes_anterior_comp?: string;
    })
  | (BaseBody & {
      Tipo_consulta_BD: CalendarRangeType.ANIO_ACTUAL;
      anio_actual: string;
      anio_actual_comp?: string;
    })
  | (BaseBody & {
      Tipo_consulta_BD: CalendarRangeType.ANIO_ANTERIOR;
      anio_anterior: string;
      anio_anterior_comp?: string;
    });

// Interfaces para la respuesta
export interface ResponseOccupationByHours {
  column_name: OccupationByHoursColumnName | Message;
}

export interface OccupationByHoursColumnName {
  'public data': DataOccupationByHours;
}

export interface DataOccupationByHours {
  anio_base: string;
  fechas: HourDataOccupationByHours[];
  resumen: OccupationSummary[];
}

export interface HourDataOccupationByHours {
  Hora: string;
  Entradas: number;
  Entradas_periodo_anterior: number;
}

export interface OccupationSummary {
  total_ocupacion: number;
  total_ocupacion_anterior: number;
  diferencia: number;
  porcentaje: string;
  indicador: string;
}
